import {LanguageType} from '@shared-types';

/**
 * Loads PrimeNG translations for the specified language
 * @param lang Language to load translations for
 * @returns Translation object for PrimeNG
 */
export async function getPrimeNgTranslation(lang: LanguageType) {
	try {
		// Using fetch instead of dynamic import to get the translations
		const response = await fetch(`/assets/i18n/primeng/${lang}.json`);
		if (!response.ok) {
			throw new Error(`Failed to load translations for ${lang}`);
		}
		const translations = await response.json();
		return translations[lang];
	} catch (error) {
		console.error(`Failed to load PrimeNG translations for ${lang}:`, error);
		return null;
	}
}
